<template>
  <div>
    <div class="row containerIndicadores col-12">
      <div class="row col-12">
        <div class="title">INDICADORES</div>
      </div>
      <div class="row col-12 indicadores-item" style="display:flex;">
        <div
          class="box-container col-12"
          v-for="item in this.indicadoresData"
          v-bind:key="item.id"
        >
          <div v-if="item.tipo === 'Cualitativo' || item.tipo === 'Cuantitativo'">
            <GraficaMunicipioIndicadorAUE :dataIndicador="item" showLittleTag :tipo="item.tipo" />
          </div>
          <div v-if="item.hasOwnProperty('tarjeta')">
            <GraficaMunicipioIndicador
              :dataIndicador="item.tarjeta"
              :idRelacionAUE = "item.id"
              showLittleTag
              :datosObjetivo="datosObjetivo={datoObjetivo: item.datoObjetivo, fechaDatoObjetivo: item.fechaDatoObjetivo, unidadMedida: item.unidadMedida}"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraficaMunicipioIndicadorAUE from './GraficaMunicipioIndicadorAUE.vue';
import GraficaMunicipioIndicador from './GraficaMunicipioIndicador.vue';
import { mapGetters } from 'vuex';
import Loading from '@/components/shared/mixins/Loading.js';

export default {
  components: {
    GraficaMunicipioIndicadorAUE,
    GraficaMunicipioIndicador
  },
  mixins: [Loading],
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData'
    })
  },
  props: {
    value: {
      required: true
    },
    indicadores: Array
  },
  data () {
    return {
      indicadoresData: []
    };
  },
  created () {
    this.indicadoresData = this.indicadores;
  },
  watch: {
    indicadores () {
      this.indicadoresData = this.indicadores;
    }
  }
};
</script>

<style lang="scss" scoped>
.box-container {
  padding: 10px;
}
  .containerIndicadores {
    display: flex;
    flex-direction: row;
    .title {
      display: flex;
      justify-content: center;
      font-family: DINPro;
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -1.21px;
      color: #002f6c;
      margin-left: 10px;
    }
}

@media (max-width: 640px) {
  ::v-deep {
    .title {
      font-size: 85% !important;
    }
  }
}
</style>
